@if(contrast < 4.5) {
  <app-badge [label]="{id: 0, name: '' + contrast, backcolor: '#9E3131', textcolor: '#ffffff'}"/>
} @else if(contrast > 4.5 && contrast < 7) {
  <app-badge [label]="{id: 0, name: '' + contrast, backcolor: '#000CFF', textcolor: '#ffffff'}"/>
} @else {
  <app-badge [label]="{id: 0, name: '' + contrast, backcolor: '#006624', textcolor: '#ffffff'}"/>
}
